import { getApi } from "@beeldit/core/helpers/api";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";

export default function changePasswordAdmin(
  userId: number,
  data: { password: string; password_confirmation: string },
  onSuccess: () => void,
  onError: (e: any) => void,
  setBackendErrors?: (e: any) => void
) {
  const run = async () => {
    try {
      await getApi().post(`/users/${userId}/admin/change-password`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      showSuccessMessage("successfull_action");
      onSuccess();
    } catch (error: any) {
      if (error?.response?.status === 422 && setBackendErrors) {
        setBackendErrors(error?.response?.data?.errors || null);
      } else {
        onError(error);
      }
    }
  };
  run();
}
